module.exports = __webpack_public_path__ + "img/gamma_logo.99a9fab7.png";